import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function SoftwareBanner() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-white px-6 pb-24">
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="max-w-[1440px] mx-auto bg-[#f8f9fa] rounded-[32px] overflow-hidden flex flex-col lg:flex-row items-center justify-between border border-gray-100"
      >
        
        {/* 左侧：软件界面区域 */}
        {/* 适当微调 padding，给软件外壳留出呼吸空间 */}
        <div className="w-full lg:w-[60%] flex items-center justify-center p-6 lg:p-12 relative">
          
          {/* 【核心优化】精修的软件窗口外壳（Mockup） */}
          <div className="w-full rounded-xl overflow-hidden bg-white shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-200/60">
            
            {/* 模拟 Mac 浏览器的顶部三个小圆点（高级感细节，可要可不要） */}
            <div className="bg-gray-50 px-4 py-3 flex gap-1.5 border-b border-gray-200/60">
              <div className="w-2.5 h-2.5 rounded-full bg-gray-300"></div>
              <div className="w-2.5 h-2.5 rounded-full bg-gray-300"></div>
              <div className="w-2.5 h-2.5 rounded-full bg-gray-300"></div>
            </div>

            {/* 真实的软件图片：去掉 mix-blend-multiply，保持原有纯白与高清色彩 */}
            <img 
              src={t('software.OSynergyImagePath')}
              alt="O-Synergy Dashboard" 
              className="w-full h-auto object-contain block"
            />
          </div>

        </div>

        {/* 右侧：文案区（保持不变） */}
        <div className="w-full lg:w-[40%] flex flex-col justify-center p-8 lg:p-16 text-left">
          {/* 【修改点】：使用 clamp 让标签字体在 12px 到 16px 之间随屏幕宽度平滑变化 */}
          <span className="text-[clamp(12px,1.5vw,16px)] font-bold text-gray-500 mb-6 tracking-widest">
            {t('software.tagline')}
          </span>
          {/* 【修改点】：使用 clamp 让大标题从手机端 28px 无缝过渡到电脑端 52px */}
          <h2 className="text-[clamp(28px,4vw,52px)] font-extrabold text-black mb-6 leading-tight tracking-wide">
            {t('software.title')}
          </h2>
          {/* 【修改点】：使用 clamp 让描述文本从手机端 16px 无缝过渡到电脑端 24px */}
          <p className="text-[clamp(16px,2vw,24px)] text-gray-700 tracking-wide">
            {t('software.description')}
          </p>
        </div>

      </motion.div>
    </section>
  );
}